module.exports = __webpack_public_path__ + "img/2025-03-12e_1.dc6d244c.jpg";